import { 
    LOG_OUT_USER,
    FETCH_MAINTENANCES,
    ADD_MAINTENANCE,
    DELETE_MAINTENANCE
 } from '../../actions/actionTypes';
 import { removeArrayElement } from "../../../utils/general";


 const fetchMaintenancesReducer = (maintenancesOrder, payload) => {
    let newMaintenances = payload.appendData ? [ ...maintenancesOrder ] : [];
    if (payload.maintenances && payload.maintenances.length > 0){
        for(let m of payload.maintenances){
            newMaintenances.push(m.maintenanceId);
        }
    }
    
    let uniqueIds = [...new Set(newMaintenances)];
    return uniqueIds;
}

const addMaintenanceReducer = (maintenancesOrder, payload) => {
    let newMaintenances = [ ...maintenancesOrder ];
    if (payload.addToOrder){
        newMaintenances.unshift(payload.maintenance.maintenanceId)
    }
    return newMaintenances;
}

const deleteMaintenanceReducer = (maintenancesOrder, payload) => {
    let newMaintenances = [ ...maintenancesOrder ];
    let remainingMaintenances = removeArrayElement(newMaintenances, payload.maintenanceId)
    
    return remainingMaintenances;
}

const maintenancesOrderReducer = (state=[], action) => {
    let maintenancesOrder = state;
    if(action && action.payload && !action.payload.errors){
        switch(action.type){
            case FETCH_MAINTENANCES:
                return fetchMaintenancesReducer(maintenancesOrder, action.payload);
            case ADD_MAINTENANCE:
                return addMaintenanceReducer(maintenancesOrder, action.payload);
            case DELETE_MAINTENANCE:
                return deleteMaintenanceReducer(maintenancesOrder, action.payload);  
            case LOG_OUT_USER:
                return [];
            default:
                return maintenancesOrder;
        }
    }
    return maintenancesOrder;
}

export default maintenancesOrderReducer;